import Script from 'next/script'
import { NotifiableError } from '@bugsnag/js'
import Bugsnag from '@bugsnag/js'

interface ScriptTagsProps {
  nonce: string
}

export const ScriptTags = ({ nonce }: ScriptTagsProps) => {
  return (
    <>
      <Script
        nonce={nonce}
        src={`${process.env.NEXT_PUBLIC_TOKENEX_BASE_URL}/Iframe/iframe-v3.41.min.js`}
        // https://nextjs.org/docs/pages/building-your-application/optimizing/scripts#strategy
        // Loads the script early but after some hydration on the page occurs.
        strategy="afterInteractive"
        onError={(e: NotifiableError) => {
          console.error('Tokenex failed to load.')
          Bugsnag.notify(e)
        }}
      />
      <Script id="facebook-pixel" nonce={nonce}>
        {`
          !function(f,b,e,v,n,t,s)
          {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
          n.callMethod.apply(n,arguments):n.queue.push(arguments)};
          if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
          n.queue=[];t=b.createElement(e);t.async=!0;
          t.src=v;s=b.getElementsByTagName(e)[0];
          s.parentNode.insertBefore(t,s)}(window, document,'script',
          'https://connect.facebook.net/en_US/fbevents.js');
        `}
      </Script>

      <Script id="heap-config" nonce={nonce}>
        {`
          window.heapReadyCb = window.heapReadyCb || [];
          window.heap = window.heap || {};
          heap.load = function (e, t) {
            window.heap.envId = e;
            window.heap.clientConfig = t = t || {};
            window.heap.clientConfig.shouldFetchServerConfig = false;
            var n = ["init", "startTracking", "stopTracking", "track", "resetIdentity", "identify", "getSessionId", "getUserId", "getIdentity", "addUserProperties", "addEventProperties", "removeEventProperty", "clearEventProperties", "addAccountProperties", "addAdapter", "addTransformer", "addTransformerFn", "onReady", "addPageviewProperties", "removePageviewProperty", "clearPageviewProperties", "trackPageview"];
            var i = function (e) { return function () { var t = Array.prototype.slice.call(arguments, 0); window.heapReadyCb.push({ name: e, fn: function () { heap[e] && heap[e].apply(heap, t); } }) } };
            for (var p = 0; p < n.length; p++) heap[n[p]] = i(n[p]);
          };
          heap.load("${process.env.NEXT_PUBLIC_HEAP_APP_ID}", {
            metadataStorage: "localstorage",
            eventPropertiesStorage: "localstorage",
          });
        `}
      </Script>

      <Script
        async
        nonce={nonce}
        type="text/javascript"
        src={`https://cdn.us.heap-api.com/config/${process.env.NEXT_PUBLIC_HEAP_APP_ID}/heap_config.js`}
      />
    </>
  )
}
